import { Endpoint } from '@business/api/endpoint';
import { R } from '@core/utils/r';
import { CompactFeedbackResponse, FeedbackId } from '@business/entities/feedback';
import { FeedbackFormData } from '@modules/common/FeedbackModal/FeedbackModal';

export function fetchFeedbacks(options?: { search: '' }) {
  const params = R.objectCompact(options);
  return Endpoint.get<CompactFeedbackResponse[]>(`@gc/feedbacks`, { params });
}

export function fetchFeedback(id: FeedbackId) {
  return Endpoint.get<CompactFeedbackResponse>(`@gc/feedbacks/feedback/${id}`);
}

export function createFeedback(objectId: string, type: string, data: FeedbackFormData) {
  return Endpoint.post<CompactFeedbackResponse>(`@gc/feedbacks`, { data: { objectId, type, ...data } });
}
